
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class HolidayListGrid extends Serenity.EntityGrid<HolidayListRow, any> {
        protected getColumnsKey() { return 'HR.HolidayList'; }
        protected getDialogType() { return HolidayListDialog; }
        protected getIdProperty() { return HolidayListRow.idProperty; }
        protected getInsertPermission() { return HolidayListRow.insertPermission; }
        protected getLocalTextPrefix() { return HolidayListRow.localTextPrefix; }
        protected getService() { return HolidayListService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}